import React, { Fragment } from 'react';
import { Dropdown } from 'react-bootstrap';
import { DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup,  InputGroupText } from 'reactstrap';
import { ArcaHttpClientPerson } from '../../../code/ArcaHttpClientPerson';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { PrePendText } from './PrePendText';

export class PersonSelect extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            status: null,
            mandatory: this.props.mandatory,
            fieldValid: null,
            dropdownOpen: false,
            label: this.props.label ?? this.props.fieldname,
            people: [],
            prependWidth: this.props.prependWidth ?? '160px',
            inline: this.props.inline ?? false,
            canClear: this.props.canClear ?? false
        };
    }

    async componentDidMount() {
        ArcaHttpClientPerson.GetByTypeAsync(
            this.props.type,
            true,
            0,
            ((persons) => this.setState({ people: persons })),
            ((status) => alert(status))
        );
    }

    render() {

        let { prependWidth, mandatory, showHelp, description, label, inline } = this.state;
        let prependText = <PrePendText
            prependWidth={prependWidth}
            mandatory={mandatory}
            label={label}
            description={description}
            showHelp={showHelp}
            onClick={(() => this.setState({ showHelp: !showHelp }))}
        />

        return (
            <Fragment>
                <InputGroup>
                    {!inline ? prependText : null}
                </InputGroup>
                <InputGroup>
                    {inline ? prependText : null}  

                    <Input fieldname='label' value={this.state.value ? this.state.value.Fullname: ''} readOnly={true}></Input>

                    <Dropdown addonType="append" isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown.bind(this)}>
                        <DropdownToggle className='selectDropdown' caret color="secondary" >
                            Select
                        </DropdownToggle>
                        <DropdownMenu>
                            {this.state.canClear
                                ? <DropdownItem onClick={this.handleUserInput.bind(this, null)}>[Clear field]</DropdownItem>
                                : null}
                            {this.state.people?.map((person, key) =>
                                <DropdownItem key={key} onClick={this.handleUserInput.bind(this, person)}>{person.Fullname}</DropdownItem>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                </InputGroup>
            </Fragment>
        );
    }

    toggleDropDown() {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }

    handleUserInput(person, e) {

        var valid = true;
        var value = person;
        this.props.onUpdate(value, valid, this.props.fieldname);

        this.setState({ value: value, fieldValid: valid });
    }
}